module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('transition', {
    attrs: {
      "name": "v-transition-main-views"
    }
  }, [_c('router-view', {})], 1), _vm._v(" "), _c('nks-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-bd26cd6c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 24
// module chunks = 0